// extracted by mini-css-extract-plugin
module.exports = {"container":"categorizerStub__container___1Bsvg"};